import { render, staticRenderFns } from "./infoTabela.vue?vue&type=template&id=129450aa&scoped=true"
import script from "./infoTabela.vue?vue&type=script&lang=js"
export * from "./infoTabela.vue?vue&type=script&lang=js"
import style0 from "./infoTabela.vue?vue&type=style&index=0&id=129450aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129450aa",
  null
  
)

export default component.exports